<template>
  <div>
    <v-card color="" elevation="6">
      <v-card-title class="text-right justify-center py-6">
      </v-card-title>

      <v-tabs
          v-model="tab"
          background-color="transparent"
          color="basil"
          icons-and-text
          grow
      >
        <v-tab
            v-for="item in items"
            :key="item.name"
            style="font-size: 12pt;color:darkblue"
        >
          {{ item.site }}
          <span class="svg-icon svg-icon-primary svg-icon-3x">
<!--            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512"-->
<!--                 style="enable-background:new 0 0 512 512;" xml:space="preserve">-->
<!--                   <g>-->
<!--	<g>-->
<!--		<g>-->
<!--			<path-->
<!--          d="M460.8,32.337H210.189v-2.695C210.189,13.298,196.891,0,180.547,0H94.316C77.972,0,64.674,13.298,64.674,29.642v2.695     H51.2c-28.231,0-51.2,22.969-51.2,51.2v21.558v301.811c0,28.231,22.969,51.2,51.2,51.2h185.937v24.253     c0,16.344,13.298,29.642,29.642,29.642h118.568c16.344,0,29.642-13.298,29.642-29.642v-24.253H460.8     c28.231,0,51.2-22.969,51.2-51.2V105.095V83.537C512,55.306,489.031,32.337,460.8,32.337z M80.842,29.642     c0-7.43,6.044-13.474,13.474-13.474h86.232c7.43,0,13.474,6.044,13.474,13.474v67.368H80.842V29.642z M16.168,83.537     c0-19.317,15.715-35.032,35.032-35.032h13.474v48.505H16.168V83.537z M237.137,267.538v120.504h-153.6     c-7.43,0-13.474-6.044-13.474-13.474V191.326c0-7.43,6.044-13.474,13.474-13.474h207.495v37.891l-40.695,27.13     C242.071,248.384,237.137,257.604,237.137,267.538z M398.821,482.358c0,7.43-6.044,13.474-13.474,13.474H266.779     c-7.43,0-13.474-6.044-13.474-13.474v-214.82c0-4.515,2.243-8.706,6-11.211l31.727-21.15v4.655c0,7.396,2.31,14.259,6.238,19.921     c-0.55,2.254-0.848,4.606-0.848,7.027c0,16.344,13.298,29.642,29.642,29.642s29.642-13.298,29.642-29.642     s-13.298-29.642-29.642-29.642c-6.984,0-13.408,2.434-18.479,6.49c-0.251-1.226-0.384-2.495-0.384-3.795v-15.433l11.39-7.594     c2.27-1.513,4.871-2.27,7.473-2.27c2.601,0,5.204,0.757,7.474,2.27l59.284,39.522c3.756,2.505,6,6.696,6,11.211V482.358z      M326.063,258.695c-3.151,0-6.117-0.786-8.731-2.158c2.353-2.01,5.4-3.232,8.731-3.232c7.43,0,13.474,6.044,13.474,13.474     s-6.044,13.474-13.474,13.474c-5.297,0-9.877-3.08-12.077-7.536c3.767,1.387,7.834,2.146,12.077,2.146     c4.466,0,8.084-3.618,8.084-8.084C334.147,262.313,330.529,258.695,326.063,258.695z M401.79,242.873l-59.283-39.522     c-9.99-6.661-22.898-6.66-32.885,0l-2.421,1.615v-27.113h121.263c7.43,0,13.474,6.044,13.474,13.474v183.242     c0,7.43-6.044,13.474-13.474,13.474h-13.474V267.538C414.989,257.604,410.055,248.384,401.79,242.873z M309.046,161.684     c3.034-6.362,9.511-10.779,17.017-10.779s13.981,4.417,17.017,10.779H309.046z M495.832,406.905     c0,19.317-15.715,35.032-35.032,35.032h-45.811v-37.726h13.474c16.344,0,29.642-13.298,29.642-29.642V191.326     c0-16.344-13.298-29.642-29.642-29.642h-68.32c-3.661-15.43-17.546-26.947-34.08-26.947s-30.419,11.517-34.08,26.947H83.537     c-16.344,0-29.642,13.298-29.642,29.642v183.242c0,16.344,13.298,29.642,29.642,29.642h153.6v37.726H51.2     c-19.317,0-35.032-15.715-35.032-35.032V113.179h479.663V406.905z M495.832,97.011H210.189V48.505H460.8     c19.317,0,35.032,15.715,35.032,35.032V97.011z"/>-->
<!--			<path d="M417.684,64.135c-4.466,0-8.084,3.618-8.084,8.084v1.078c0,4.466,3.619,8.084,8.084,8.084s8.084-3.618,8.084-8.084     v-1.078C425.768,67.753,422.15,64.135,417.684,64.135z"/>-->
<!--			<path d="M385.347,64.135c-4.466,0-8.084,3.618-8.084,8.084v1.078c0,4.466,3.618,8.084,8.084,8.084     c4.466,0,8.084-3.618,8.084-8.084v-1.078C393.432,67.753,389.813,64.135,385.347,64.135z"/>-->
<!--			<path d="M450.021,64.135c-4.466,0-8.084,3.618-8.084,8.084v1.078c0,4.466,3.618,8.084,8.084,8.084     c4.466,0,8.084-3.618,8.084-8.084v-1.078C458.105,67.753,454.487,64.135,450.021,64.135z"/>-->
<!--		</g>-->
<!--	</g>-->
<!--</g>-->
<!--</svg>-->

            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.38553 14.6173H8.28043C7.89506 14.5647 7.63232 14.1969 7.68487 13.8115C8.15781 10.6936 8.31546 5.71887 8.31546 5.68384C8.35049 5.29848 8.64827 4.98318 9.05115 5.0007C9.43652 5.01821 9.7343 5.33351 9.7343 5.71887C9.7343 5.92907 9.55913 10.8162 9.08619 14.0217C9.03364 14.372 8.73586 14.6173 8.38553 14.6173ZM18.4225 15.9135C18.1247 15.9135 17.8444 15.7208 17.7569 15.423C17.6342 15.0552 17.8444 14.6523 18.2123 14.5472C21.5229 13.4962 21.5754 12.6904 21.593 12.2525C21.628 11.5694 21.1025 10.6936 20.8923 10.3958C20.6646 10.0805 20.7347 9.64257 21.05 9.41485C21.3652 9.18714 21.8032 9.2572 22.0309 9.5725C22.136 9.71263 23.0819 11.0264 22.9943 12.3401C22.9067 13.9341 21.6805 14.915 18.6327 15.896C18.5976 15.896 18.5626 15.9003 18.5276 15.9047C18.4925 15.9091 18.4575 15.9135 18.4225 15.9135ZM8.91102 18.3833C8.70082 18.3833 8.49063 18.2957 8.36801 18.1206C8.12278 17.8228 8.17533 17.3673 8.49063 17.1396C9.92698 16.0011 10.8904 14.9851 11.521 14.0918C11.1706 13.9166 10.8028 13.6538 10.6101 13.2159C10.435 12.8131 10.3299 12.1474 10.9429 11.2541C11.8188 9.95786 12.6946 9.66008 13.0274 9.59002C13.4828 9.50244 13.9207 9.76518 14.0434 10.2031C14.1309 10.5184 14.3411 11.5168 13.7105 13.0408C14.5513 13.0233 15.217 12.7955 15.7249 12.3751C16.7059 11.5869 16.7584 10.2556 16.7584 10.2381C16.7759 9.85277 17.0912 9.55498 17.4766 9.55498C17.8619 9.5725 18.1597 9.8878 18.1597 10.2732C18.1597 10.3432 18.0897 12.2175 16.6358 13.4436C15.7249 14.2144 14.4813 14.5472 12.9748 14.4246C12.2567 15.5281 11.1181 16.8243 9.34893 18.2256C9.2088 18.3307 9.06867 18.3833 8.91102 18.3833ZM12.7121 11.3066C12.5194 11.4643 12.3092 11.692 12.0815 12.0423C11.8538 12.3927 11.8363 12.5853 11.8538 12.6379C11.8888 12.7255 12.064 12.8131 12.2392 12.8831C12.572 12.2175 12.6771 11.692 12.7121 11.3066ZM12.8873 16.2288C12.9048 16.6141 13.2201 16.9119 13.5879 16.9119H13.623C13.6755 16.9119 14.8491 16.8769 16.5307 16.4915C16.9161 16.4039 17.1613 16.0361 17.0737 15.6507C16.9861 15.2654 16.6183 15.0201 16.2329 15.1077C14.6739 15.4405 13.5704 15.4931 13.5529 15.4931C13.1675 15.5106 12.8697 15.8434 12.8873 16.2288ZM1.1337 18.103C1.25631 18.2782 1.48403 18.3833 1.69423 18.3833C1.83436 18.3833 1.97449 18.3483 2.11462 18.2607C6.56381 15.0201 6.73898 10.7811 6.73898 10.606C6.73898 10.2206 6.4412 9.90531 6.05583 9.8878C5.67047 9.87028 5.35517 10.1856 5.33766 10.5709C5.33766 10.7111 5.16249 14.302 1.29135 17.1221C0.976049 17.3498 0.905983 17.7877 1.1337 18.103Z" fill="#A62626"/>
</svg>
        </span>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item
            v-for="item in items"
            :key="item.name"

        >
          <v-row class="px-5 mt-3" cols="12">
            <v-col
                cols="12"
                sm="6"
                class="d-flex"
            >
              <v-select
                  :items="adsTypes"
                  label="نوع آگهی خود را انتخاب کنید"
                  outlined
                  v-model="ads_type"
                  item-text="type"
                  required

              ></v-select>
            </v-col>
            <v-col
                cols="12"
                sm="6"
                class="d-flex"
                v-if="ads_type==='آگهی تکی' || ads_type==='آگهی گروهی'"
            >
            </v-col>
            <v-col
                cols="12"
                sm="6"
                class="d-flex"
                v-if="ads_type==='آگهی فروشگاهی' || ads_type==='ارسال آگهی' || ads_type==='نردبان آگهی'"
            >
              <v-select
                  :items="ads_models"
                  label="مدل آگهی خود را انتخاب کنید"
                  outlined
                  v-model="ads_model"
                  item-text="name"

              ></v-select>
            </v-col>

          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "adsSelector",
  data() {
    return {
      tab: null,
      items: [
        {
          name: 'دیوار',
          site: 'سایت رایگان دیوار',
          svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/></svg>',
        },
        {
          name: 'شیپور',
          site: 'سایت رایگان شیپور',
          svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/></svg>',
        },
        {
          name: 'باما',
          site: 'سایت رایگان باما',
          svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/></svg>',
        },
        {
          name: 'همشهری',
          site: 'سایت رایگان همشهری',
          svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/></svg>',
        },
        {
          name: 'ایستگاه',
          site: 'سایت رایگان ایستگاه',
          svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/></svg>',
        },
        {
          name: '24',
          site: 'سایت رایگان 24',
          svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/></svg>',
        },
      ],
      adsTypes: [
        {type: 'آگهی تکی'},
        {type: 'آگهی گروهی'},
        {type: 'آگهی هوشمند'},
        {type: 'آگهی تدریجی'},

      ],
      ads_type: 'آگهی تکی',
      ads_models: ['تدریجی', 'هوشمند'],
      ads_model: '',

    }
  },
  methods:{
    compeleted(){
      if (this.ads_type!=='' && this.ads_model!=='' || this.ads_type!=='' && this.ads_time!=='')
        return true;
      else
        return false
    }
  },
  mounted() {
    this.$emit('Data',this.compeleted());
  }
}
</script>

<style scoped>

.basil {
  background-color: #f09e00 !important;
}


</style>